module.exports = __webpack_public_path__ + "assets/pressure-gauge.76ee4249.svg";